import { createFileRoute } from '@tanstack/react-router'
import { SessionGatePage } from '@/pages/session-gate/ui/SessionGatePage'

export const Route = createFileRoute('/')({
  component: SessionGatePage,
})
